import Immutable from 'immutable';
import {
  FLAG_GETTING_AUTHORIZED_PROFILES,
  GET_AUTHORIZED_PROFILES,
  CLEAR_AUTHORIZED_PROFILES,
  GET_AUTHORIZED_PROFILE,
  CLEAR_AUTHORIZED_PROFILE,
  FLAG_AUTHORIZED_PROFILE_ACTIVITY,
  GET_AUTHORIZED_PROFILES_BY_PROFILE_ID,
  CLEAR_AUTHORIZED_PROFILES_BY_PROFILE_ID,
  FLAG_GETTING_ALL_AUTHORIZED_PROFILES_PER_LOGGED_IN_USER,
  GET_ALL_AUTHORIZED_PROFILES_PER_LOGGED_IN_USER,
  CLEAR_ALL_AUTHORIZED_PROFILES_PER_LOGGED_IN_USER,
} from '../../../actions/types/security';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  allAuthorizedProfilesPerLoggedInUser: Immutable.Map({
    content: Immutable.Set(),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
    authorizedProfilesByProfileId: Immutable.Set(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_AUTHORIZED_PROFILES:
      return state.setIn(['all', 'loading'], payload);
    case GET_AUTHORIZED_PROFILES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_AUTHORIZED_PROFILES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_AUTHORIZED_PROFILE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_AUTHORIZED_PROFILE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_AUTHORIZED_PROFILE_ACTIVITY:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_AUTHORIZED_PROFILES_BY_PROFILE_ID:
      return state.setIn(
        ['current', 'authorizedProfilesByProfileId'],
        Immutable.Set(payload),
      );
    case CLEAR_AUTHORIZED_PROFILES_BY_PROFILE_ID:
      return state.setIn(
        ['current', 'authorizedProfilesByProfileId'],
        INITIAL_STATE.getIn(['current', 'authorizedProfilesByProfileId']),
      );
    case FLAG_GETTING_ALL_AUTHORIZED_PROFILES_PER_LOGGED_IN_USER:
      return state.setIn(
        ['allAuthorizedProfilesPerLoggedInUser', 'loading'],
        payload,
      );
    case GET_ALL_AUTHORIZED_PROFILES_PER_LOGGED_IN_USER:
      return state.setIn(
        ['allAuthorizedProfilesPerLoggedInUser', 'content'],
        Immutable.Set(payload),
      );
    case CLEAR_ALL_AUTHORIZED_PROFILES_PER_LOGGED_IN_USER:
      return state.setIn(
        ['allAuthorizedProfilesPerLoggedInUser', 'content'],
        INITIAL_STATE.getIn([
          'allAuthorizedProfilesPerLoggedInUser',
          'content',
        ]),
      );
    default:
      return state;
  }
};
